import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import Img_Background from '../../image/home_background.svg';
import Icon_Schneider from '../../image/icons/hero/Schneider.png';
import Icon_Niagara from '../../image/icons/hero/Niagara.png';
import Icon_Paneelbouw from '../../image/icons/hero/Paneelbouw.png';
import Icon_Software from '../../image/icons/hero/Software.png';
import Icon_Commissioning from '../../image/icons/hero/Commissioning.png';

export const HeroSection = ({ heroAutoHighlightIndex, heroCapabilities }) => {
  const { t } = useTranslation();

  return (
    <div class="vb-home-title-box">
      <div class="row">
        <div class="col-lg-12">
          <div class="vb-abs-overlay">
            <div class="row vb-padding-mobile">
              <div class="p-3 col-12 vb-home-video-overlay">
                <h1 class="vb-home-title vb-home-title-wide">{t('home.hero.title')}</h1>
              </div>

              <div class="col-12 vb-home-video-overlay">
                <div class="row vb-home-feature-grid">
                  <div class="p-3 col-lg-4 col-md-6 col-sm-12">
                    <div class="vb-home-feature-card">
                      <h3 class="vb-md-title"><span class="vb-md-title-emphasis"><span class="vb-gacs-highlight">{t('home.hero.features.reliability.highlight')}</span> {t('home.hero.features.reliability.suffix')}</span></h3>
                      <h4 class="vb-sm-title">{t('home.hero.features.reliability.description')}</h4>
                    </div>
                  </div>
                  <div class="p-3 col-lg-4 col-md-6 col-sm-12">
                    <div class="vb-home-feature-card">
                      <h3 class="vb-md-title"><span class="vb-md-title-emphasis"><span class="vb-gacs-highlight">{t('home.hero.features.gacs.highlight')}</span> {t('home.hero.features.gacs.suffix')}</span></h3>
                      <h5 class="vb-sm-title">{t('home.hero.features.gacs.description')}</h5>
                    </div>
                  </div>
                  <div class="p-3 col-lg-4 col-md-12 col-sm-12">
                    <div class="vb-home-feature-card">
                      <h3 class="vb-md-title"><span class="vb-md-title-emphasis">{t('home.hero.features.insight.prefix')} <span class="vb-gacs-highlight">{t('home.hero.features.insight.highlight')}</span></span></h3>
                      <h4 class="vb-sm-title">{t('home.hero.features.insight.description')}</h4>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 vb-home-video-overlay">
                <div class="vb-hero-capabilities-block">
                  <div class="vb-hero-capabilities-grid">
                    <div class={`vb-hero-capability-item vb-hero-capability-item--panelbouw ${heroAutoHighlightIndex === 0 ? 'vb-hero-capability-item--auto-active' : ''}`}>
                      <span class="vb-hero-capability-icon vb-hero-capability-icon--asset">
                        <img src={Icon_Paneelbouw} alt={t('home.hero.iconAlt.panel')} class="vb-hero-capability-icon-image vb-hero-capability-icon-image--asset"></img>
                      </span>
                      <h6>{heroCapabilities[0] || ''}</h6>
                    </div>
                    <div class={`vb-hero-capability-item vb-hero-capability-item--software ${heroAutoHighlightIndex === 1 ? 'vb-hero-capability-item--auto-active' : ''}`}>
                      <span class="vb-hero-capability-icon vb-hero-capability-icon--asset">
                        <img src={Icon_Software} alt={t('home.hero.iconAlt.software')} class="vb-hero-capability-icon-image vb-hero-capability-icon-image--asset"></img>
                      </span>
                      <h6>{heroCapabilities[1] || ''}</h6>
                    </div>
                    <div class={`vb-hero-capability-item vb-hero-capability-item--commissioning ${heroAutoHighlightIndex === 2 ? 'vb-hero-capability-item--auto-active' : ''}`}>
                      <span class="vb-hero-capability-icon vb-hero-capability-icon--asset">
                        <img src={Icon_Commissioning} alt={t('home.hero.iconAlt.commissioning')} class="vb-hero-capability-icon-image vb-hero-capability-icon-image--asset"></img>
                      </span>
                      <h6>{heroCapabilities[2] || ''}</h6>
                    </div>
                    <div class={`vb-hero-capability-item vb-hero-capability-item--niagara ${heroAutoHighlightIndex === 3 ? 'vb-hero-capability-item--auto-active' : ''}`}>
                      <span class="vb-hero-capability-icon vb-hero-capability-icon--asset">
                        <img src={Icon_Niagara} alt={t('home.hero.iconAlt.niagara')} class="vb-hero-capability-icon-image vb-hero-capability-icon-image--asset"></img>
                      </span>
                      <h6>{heroCapabilities[3] || ''}</h6>
                    </div>
                    <div class={`vb-hero-capability-item vb-hero-capability-item--schneider ${heroAutoHighlightIndex === 4 ? 'vb-hero-capability-item--auto-active' : ''}`}>
                      <span class="vb-hero-capability-icon vb-hero-capability-icon--logo">
                        <img src={Icon_Schneider} alt={t('home.hero.iconAlt.schneider')} class="vb-hero-capability-icon-image"></img>
                      </span>
                      <h6>{heroCapabilities[4] || ''}</h6>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-12 vb-home-video-overlay">
                <div class="row justify-content-center vb-home-cta-row">
                  <div class="col-sm-12 col-md-10 col-lg-5 col-xl-4 p-4">
                    <Link to="/contact" style={{ textDecoration: 'none' }}>
                      <button id="about" type="submit" class="btn btn-primary vb-home-title-button">{t('common.contactCta')}</button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <img src={Img_Background} class="vb-home-background" alt=""></img>
          </div>
        </div>
      </div>
    </div>
  );
};
